import { createAction } from '@reduxjs/toolkit';
import { SignInPayload, SignInResponse } from 'features/auth/api/types';

export const authActions = {
  clearErrors: createAction('[auth]CLEAR_ERRORS'),

  checkAuthRequest: createAction('[auth]CHECK_AUTH_REQUEST'),
  checkAuthSuccess: createAction('[auth]CHECK_AUTH_SUCCESS'),
  checkAuthFailure: createAction('[auth]CHECK_AUTH_FAILURE'),

  signInRequest: createAction<SignInPayload>('[auth]SIGN_IN_REQUEST'),
  signInSuccess: createAction<SignInResponse>('[auth]SIGN_IN_SUCCESS'),
  signInFailure: createAction<string[]>('[auth]SIGN_IN_FAILURE'),

  signOutRequest: createAction('[auth]SIGN_OUT_REQUEST'),
  signOutSuccess: createAction('[auth]SIGN_OUT_SUCCESS'),
  signOutFailure: createAction<string[]>('[auth]SIGN_OUT_FAILURE'),

  refreshTokenRequest: createAction('[auth]REFRESH_TOKEN_REQUEST'),
  refreshTokenSuccess: createAction<string>('[auth]REFRESH_TOKEN_SUCCESS'),
  refreshTokenFailure: createAction<string[]>('[auth]REFRESH_TOKEN_FAILURE'),
};
